import { render, staticRenderFns } from "./DashboardApplicationsList.vue?vue&type=template&id=e15c5252&scoped=true"
import script from "./DashboardApplicationsList.vue?vue&type=script&lang=js"
export * from "./DashboardApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./DashboardApplicationsList.vue?vue&type=style&index=0&id=e15c5252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15c5252",
  null
  
)

export default component.exports